import { render, staticRenderFns } from "./BackgroundTriangle.vue?vue&type=template&id=37a4fdd7&scoped=true&"
import script from "./BackgroundTriangle.vue?vue&type=script&lang=js&"
export * from "./BackgroundTriangle.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundTriangle.vue?vue&type=style&index=0&id=37a4fdd7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4fdd7",
  null
  
)

export default component.exports